__turbopack_context__.v({
  "collapseBtn": "default-module-sass-module__mA-rdW__collapseBtn",
  "customDropdown": "default-module-sass-module__mA-rdW__customDropdown",
  "header": "default-module-sass-module__mA-rdW__header",
  "opened": "default-module-sass-module__mA-rdW__opened",
  "registerBtn": "default-module-sass-module__mA-rdW__registerBtn",
  "walletButton": "default-module-sass-module__mA-rdW__walletButton",
  "walletIcon": "default-module-sass-module__mA-rdW__walletIcon",
});
